import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ChangePasswordService {

  constructor(
    private http: HttpClient,
  ) { }

  updatePassword(token: string, newPassword: string): Observable<{ status: string, message: string }> {
    return this.http.post<{ status: string, message: string }>(
      `${environment.apiUrl}/password/recover`,
      { token , password: newPassword }
    );
  }

  validateToken(token: string){
    return this.http.post<{ status: boolean, message: string }>(
          `${environment.apiUrl}/password/recover/request/token`,
          { token }
        );
  }
}